import { combineReducers } from '@reduxjs/toolkit';
import dashboard from 'layouts/dashboards/store/dashboardSlice';
import userDetails from './userDetailsSlice';

export const rootReducer = combineReducers({
  dashboard,
  userDetails,
});
